(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ebay-feedback"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('frattoli-feedback')){customElements.define('frattoli-feedback',class extends HTMLElement{connectedCallback(){if(this.initialized)return;this.initialized=true;this.slides=Array.from(this.querySelectorAll('[data-cf-slide]'));if(!this.slides.length)return;this.slides.forEach((slide,i)=>slide.setAttribute('aria-label',(i+1)+' of '+this.slides.length));this.current=0;this.show(0);this.classList.add('is-ready');const controls=this.querySelector('.cf-controls');if(controls)controls.hidden=false;this.querySelector('[data-cf-prev]')?.addEventListener('click',()=>this.show(this.current-1));this.querySelector('[data-cf-next]')?.addEventListener('click',()=>this.show(this.current+1));this.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();this.show(event.key==='Home'?0:event.key==='End'?this.slides.length-1:this.current+(event.key==='ArrowRight'?1:-1))});document.addEventListener('shopify:block:select',event=>{const slide=event.target.closest('[data-cf-slide]');const index=this.slides.indexOf(slide);if(index>=0)this.show(index)})}show(index){this.current=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>{slide.hidden=i!==this.current});const counter=this.querySelector('[data-cf-current]');if(counter)counter.textContent=String(this.current+1).padStart(2,'0');const image=this.slides[this.current].querySelector('img');if(image)image.loading='eager'}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-bracelets-bands"] && !Shopify.designMode) return;
  try {
    
  function initialiseBandShops() {
    document.querySelectorAll('[data-band-shop]').forEach((shop) => {
      if (shop.dataset.filtersReady) return;
      shop.dataset.filtersReady = 'true';
      let category = 'all';
      let width = 'all';
      const update = () => {
        let count = 0;
        shop.querySelectorAll('[data-band-card]').forEach((card) => {
          card.hidden = !((category === 'all' || card.dataset.category === category) && (width === 'all' || card.dataset.width === width));
          if (!card.hidden) count += 1;
        });
        shop.querySelector('[data-band-count]').textContent = count;
        shop.querySelector('[data-band-empty]').hidden = count !== 0;
        shop.querySelector('[data-band-reset]').hidden = category === 'all' && width === 'all';
        shop.querySelectorAll('[data-band-category]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.bandCategory === category)));
        shop.querySelectorAll('[data-band-width]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.bandWidth === width)));
      };
      shop.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-band-category')) category = button.dataset.bandCategory;
        if (button.hasAttribute('data-band-width')) width = button.dataset.bandWidth;
        if (button.hasAttribute('data-band-reset')) {category = 'all';width = 'all';}
        update();
      });
      update();
    });
  }
  initialiseBandShops();
  document.addEventListener('shopify:section:load', initialiseBandShops);

  } catch(e) { console.error(e); }
})();
})();
